export default __webpack_public_path__ + "static/media/mundo.9ef56e22.png";